import type { RouteLocationNormalized } from 'vue-router';
import { routenames } from '../routenames';
import { getRedirectPathFromRoute, getSignInRedirect } from '../utils';
import { useAuthenticationStore } from '@/stores/authenticationStore';

export async function authenticationGuard(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
) {
  const isAuthenticated = await useAuthenticationStore().checkAuthentication();

  const canAccessPage = to.meta.noAuthRequired || isAuthenticated;

  // intercept, when navigating to Page that requires authentication while not being authenticated
  if (!canAccessPage) {
    if (from.name === routenames.signIn) {
      return false;
    }

    // We want to target the location we were initially trying to access before ending up on the current location.
    // This might be the situation, when `handleRedirect`-logic has taken place (from the routes-configuration).
    const redirect = getRedirectPathFromRoute(to);
    return {
      name: routenames.signIn,
      query: {
        redirect,
      },
    };
  }

  // intercept, when navigating to SignInPage while being authenticated
  if (to.name === routenames.signIn && isAuthenticated) {
    return getSignInRedirect(to);
  }
}
